module.exports = __webpack_public_path__ + "static/media/alerta-documentacion-chofer-verde.ce5a9436.svg";